const isReadyForPayment = invoice => {
  const readyStatuses = [
    'approved',
    'approved_after_issue_raised',
    'issue_raised',
  ]
  return invoice.orders.every(order => readyStatuses.includes(order.status))
}

export { isReadyForPayment }
